import { render, staticRenderFns } from "./InvoiceDeleted.vue?vue&type=template&id=ace95faa"
import script from "./InvoiceDeleted.vue?vue&type=script&lang=js"
export * from "./InvoiceDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports